import type { getPortfolios } from '@simplywallst/services';

import ListItem from '../ListItem';

import { generateName, generateDetails } from '../../utils';

type Portfolio = Awaited<
  ReturnType<typeof getPortfolios>
>['data']['data'][number];

interface Props {
  portfolio: Portfolio;
  uniqueSymbol: string;
  isLoading: boolean;
  onClick: (id: string) => void;
}

export const DeprecatedPortfolioListItem = ({
  portfolio,
  uniqueSymbol,
  isLoading,
  onClick,
}: Props) => {
  const isIncluded = portfolio.items?.data.some(
    (n) => n.unique_symbol === uniqueSymbol
  );
  return (
    <ListItem
      key={portfolio.id}
      name={portfolio.id.toString()}
      title={generateName(portfolio.name, portfolio.currency_iso)}
      details={generateDetails(
        portfolio.provider,
        portfolio.items?.data.length
      )}
      disabled={portfolio.provider !== null || isIncluded}
      handleClick={() => {
        onClick(portfolio.id.toString());
      }}
      isUpdating={isLoading}
      checked={isIncluded}
    />
  );
};
